<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">მიანიჭეთ მენიუ თანამშრომელს</h5>
        <form class="add-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addMenuToUser">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="menuID" class="ms-2">აირჩიეთ მენიუ</label>
            <Multiselect v-for="(data, i) of menuMultiselectArray" name="menuID" id="menuID" v-model="menuUserData.menuID" :options="data.options" :mode="data.mode"
                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="userID" class="ms-2">აირჩიეთ თანამშრომელი</label>
            <Multiselect v-for="(data, i) of userMultiselectArray" name="userID" id="userID" v-model="menuUserData.userID" :options="data.options" :mode="data.mode"
                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import Multiselect from '@vueform/multiselect';
export default {
  data(){
    return {
      menuUserData: {
        menuID: null,
        userID: null,
      },
      menuMultiselectArray: [{
        placeholder: "მენიუ",
        options: [],
        Vmodel: null,
        mode: "single",
        isDisabled: false,
      }],
      userMultiselectArray: [{
        placeholder: "თანამშრომელი",
        options: [],
        Vmodel: null,
        mode: "single",
        isDisabled: false,
      }],
      isSending: false,
    }
  },
  components: {
    secondaryButton,
    primaryButtonComponent,
    Multiselect,
  },
  mounted(){
    this.setMenus();
    this.getUsers();
  },
  methods: {
    setMenus(){
      this.getMenus();
      // if(this.$store.state.userInfo.added_by == 0){
      // }else{
      //   this.getAllMenusForOrganizationUsers();
      // }
    },
    getUsers(){
        this.$store.dispatch("getUsers").then((response) =>  {
          let tempArray = [];
          for(let user of response.data){
            if(user.userID){
              tempArray.push({
                value: user.userID,
                label: {
                  en: `${user.nameeng} ${user.surename}`,
                  ge: `${user.name} ${user.surename}`,
                }
              });
            }
          }
          
          this.userMultiselectArray[0].options = tempArray;
        });
    },
    getMenus(){
      this.$store.dispatch("getMenus").then((response) =>  {
        
        let tempArray = [];
        for(let menuObj of response.data){
          tempArray.push({
            value: menuObj.menuID,
            label: {
              en: `${menuObj.menueng} (${menuObj?.is_mobile == 0?"Admin":"App"})`,
              ge: `${menuObj.menu} (${menuObj?.is_mobile == 0?"ადმინი":"აპლიკაცია"})`,
            }
          });
          // if(menuObj?.is_mobile == 0){
          // }
        }
        this.menuMultiselectArray[0].options = tempArray;
      });
    },
    // getAllMenusForOrganizationUsers(){
    //   this.$store.dispatch("getAllMenusForOrganizationUsers").then((response) =>  {
        
    //     let tempArray = [];
    //     for(let menuObj of response.data){
    //       if(menuObj?.menu && menuObj?.is_active == 1){
    //         tempArray.push({
    //           value: menuObj.menuID,
    //           label: {
    //             en: `${menuObj.menu.menueng} (${menuObj?.menu?.is_mobile == 0?"Admin":"App"})`,
    //             ge: `${menuObj.menu.menu} (${menuObj?.menu?.is_mobile == 0?"ადმინი":"აპლიკაცია"})`,
    //           }
    //         });
    //       }
    //       // if(menuObj?.menu?.is_mobile == 0){
    //       // }
    //     }
        
    //     this.menuMultiselectArray[0].options = tempArray;
    //   });
    // },
    addMenuToUser(){
      // let ismenuIDValid = this.$helper.checkNumber(this.menuUserData.menuID);
      // let isUserIDValid = this.$helper.checkNumber(this.menuUserData.userID);

      if(this.menuUserData.menuID && this.menuUserData.userID){
        this.isSending = true;
        this.$store.dispatch("addMenuToUser", this.menuUserData).then((response) => {
        if(response.status == 201){
          this.$helper.showSwal("მენიუ წარმატებით დაემატა თანამშრომელზე", "success", "");
          setTimeout(() => {this.$router.go()}, 1500);
        }
        }).catch((error) => {
          if(error?.response?.status == 422){
            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).finally(() => {
          this.isSending = false;
        })
      }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
.add-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper, .multiselects-wrapepr{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}

#map{
    height: 500px;
    width: 100%;
}

@media screen and (max-width: 1800px) {
  .add-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-form{
    width: 90%;
  }
}
</style>
